<template>
  <section class="p-1">
    <v-card class="">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">List of Admin Users</div>
        <div>
          <bread-crumb :bread-crumbs="['List Of Users']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>

      <v-card-title>
        <v-btn
          depressed
          small
          class="text-capitalize me-3 text-decoration-none"
          color="primary"
          to="/Adduser"
          ><v-icon small>mdi-content-save-plus-outline</v-icon>Add User</v-btn
        >
        <v-btn
          depressed
          @click="downloadExcelsheet"
          class=""
          color="primary"
          small
          ><v-icon small>mdi-file-excel-outline</v-icon>Export
        </v-btn>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Type here to filter the table data."
          dense
          single-line
          hide-details
          class="mt-4"
        ></v-text-field>
      </v-card-title>
      <v-data-table
        fixed-header
        height="55vh"
        :headers="headers"
        :items="UserList"
        :search="search"
        :items-per-page="10"
        :loading="isLoading"
        loading-text="Loading... Please wait"
      >
        <template v-slot:[`item.name`]="{ item }">
          <a
            class="border-b"
            @click="
              $router.push({
                name: 'Add User',
                query: { login_id: item.login_id },
              })
            "
            >{{ item.name }}</a
          >
        </template>
        <template v-slot:[`item.password_link`]="{ item }">
          <p class="custom-transform-class" v-if="item.is_active">
            <a @click="getadminPassLink(item)" class="border-b">{{
              item.password_link
            }}</a>
          </p>

          <a
            v-else
            @click="getadminPassLink(item)"
            class="border-b disabled text-capitalize"
            >{{ item.password_link }}</a
          >
        </template>
        <template v-slot:item.two_factor_enabled="{ item }">
          <v-switch
            v-model="item.two_factor_enabled"
            height="0px"
            @click="updateTwoFactStatus(item)"
          >
          </v-switch>
        </template>
        <template v-slot:item.is_force_logout="{ item }">
          <v-btn
            v-if="item.is_force_logout"
            @click="ForceLogout(item)"
            title="Logout User"
            rounded
            fab
            x-small
          >
            <v-icon small color="primary">mdi-logout</v-icon>
          </v-btn>
        </template>
        <template v-slot:[`item.is_active`]="{ item }">
          <v-btn
            depressed
            rounded
            :color="getColor(item.is_active)"
            block
            class="no-uppercase"
            dense
            small
            v-if="item.is_active"
            dark
            @click="openStatus(item)"
          >
            Active</v-btn
          >
          <v-btn
            depressed
            rounded
            :color="getColor(item.is_active)"
            block
            class="no-uppercase"
            dense
            v-else
            small
            dark
            @click="openStatus(item)"
          >
            Block</v-btn
          >
        </template>
      </v-data-table>

      <div class="text-center">
        <v-dialog persistent v-model="Statusdialog" width="500">
          <v-card>
            <v-card-title class="grey lighten-2 subtitle-1">
              User Status
            </v-card-title>

            <v-card-text class="mt-2">
              <v-form v-model="valid" ref="UserListtatus">
                <v-row no-gutters class="d-block">
                  <v-col md="8">
                    <v-subheader class="required font-weight-bold pl-0 caption"
                      >User Status
                    </v-subheader>
                  </v-col>
                  <v-col cols="12" md="12">
                    <v-select
                      v-model="userStatus.status"
                      :items="statusList"
                      :rules="statusRules"
                      placeholder="Select User Status"
                      dense
                      outlined
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row no-gutters class="d-block">
                  <v-col md="8">
                    <v-subheader class="required font-weight-bold pl-0 caption"
                      >Remarks
                    </v-subheader>
                  </v-col>
                  <v-col cols="12" md="12">
                    <v-textarea
                      v-model="userStatus.remarks"
                      :rules="remarksRules"
                      placeholder="Enter Remarks"
                      dense
                      outlined
                      required
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-btn depressed color="red" text @click="closeStatus()">
                Cancel
              </v-btn>
              <v-btn
                depressed
                rounded
                color="primary"
                text
                @click="userStatusadmin()"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
      <OverlayPageVue :showOverlay="loaderOverlay" />
    </v-card>
  </section>
</template>

<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import alerts from "@/mixins/alerts";
// import Loading from "vue-loading-overlay";
import OverlayPageVue from "@/utils/OverlayPage.vue";
import userService from "@/services/UserService/userService.js";
export default {
  name: "List Of Users",
  mixins: [alerts],
  components: { BreadCrumb, OverlayPageVue },
  data() {
    return {
      isLoading: false,
      isPageLoader: false,
      valid: false,

      passswordlink: [],
      statusList: [
        { text: "Active", value: "true" },
        { text: "In-Active", value: "false" },
      ],
      statusRules: [(v) => !!v || "User Status is required"],
      remarksRules: [(v) => !!v || "Remarks is required"],
      dialog: false,
      userStatus: {
        id: "",
        status: "",
        remarks: "",
      },
      loaderOverlay: false,
      show_error: false,
      show_success: false,
      timeout: 3000,
      error_msg: "",
      success_msg: "",
      spStatus: null,
      Statusdialog: false,
      specificUserData: {},
      editedIndex: -1,
      componentName: "createQQPayUser",
      search: "",
      editedItem: {},
      headers: [
        { text: "ID", value: "id", align: "start" },
        { text: "Name", value: "name" },
        { text: "Role Name", value: "role_name" },
        { text: "Email", value: "email" },
        { text: "Contact Number", value: "phone_number" },
        { text: "Activation Date", value: "activation_date" },
        { text: "Password Link", value: "password_link" },
        { text: "User Status", value: "is_active" },
        { text: "Force Logout", value: "is_force_logout", align: "center" },
        { text: "2FA Status", value: "two_factor_enabled" },
        { text: "Partner Names", value: "partner_names" },
        { text: "Remarks", value: "remarks" },
        { text: "Created By", value: "created_by" },
        // { text: "Action", value: "actions", },
      ],
      UserList: [],
    };
  },

  mounted() {
    this.getAdminuserList();
  },

  methods: {
    stoploader() {
      setTimeout(() => {
        this.loaderOverlay = false;
      }, 400);
    },
    async updateTwoFactStatus(item) {
      const status = item.two_factor_enabled ? true : false;
      this.loader = true;
      try {
        const responseData = await userService.updateUsertfaStatus(
          item.login_id,
          status
        );
        if (responseData && responseData.data.status_code === 200) {
          this.stoploader();
          this.showAlertSuccess(responseData.data.message);
          this.getAdminuserList();
        } else {
          this.showAlertError(responseData.data.message);
          this.stoploader();
        }
      } catch (error) {
        console.log(error.response);
        this.showAlertError("Something went wrong please try again later.");
        this.loader = false;
      }
    },
    async downloadExcelsheet() {
      if (this.UserList) {
        this.exportToExcel(this.headers, this.UserList, "list of User");
      }
    },
    async getAdminuserList() {
      this.loaderOverlay = true;
      try {
        const response = await userService.getAdminuserList();
        if (response.data.status_code === 200) {
          this.UserList = response.data.data.reverse();
          console.log("UserList", this.UserList);
          this.stoploader();
        }
        // else if (response.data.status_code === 401) {
        //   this.UserList = [];
        //   this.returnNewToken();
        //   this.getAdminuserList();
        //   this.stoploader();
        // }
        else {
          this.UserList == [];
          this.stoploader();
        }
      } catch (error) {
        this.UserList = [];
        this.stoploader();
        console.error(error);
      }
    },
    openStatus(data) {
      console.log(data);
      this.Statusdialog = true;
      this.userStatus.id = data.id;
      this.userStatus.status = data.is_active ? "true" : "false";
      this.userStatus.remarks = data.remarks;
    },
    closeStatus() {
      this.Statusdialog = false;
    },
    getColor(is_active) {
      if (is_active) return "green";
      else return "orange";
    },

    async getadminPassLink(code) {
      this.loaderOverlay = true;
      try {
        const response = await userService.SendPassLink(code.login_id);
        if (response.data.status_code === 200) {
          this.passswordlink = response.data;
          this.showAlertSuccess(response.data.message);
          console.log("passswordlink", this.passswordlink);
          this.stoploader();
        }
        //  else if (response.data.status_code === 401) {
        //   this.passswordlink = [];
        //   this.returnNewToken();
        //   this.getadminPassLink(code);
        //   this.stoploader();
        // }
        else {
          this.passswordlink == [];
          this.showAlertError("Something went wrong please try again later.");
          this.stoploader();
        }
      } catch (error) {
        this.passswordlink = [];
        this.stoploader();
        console.error(error);
      }
    },
    async ForceLogout(item) {
      this.loaderOverlay = true;
      try {
        const response = await userService.userForceLogout({
          login_id: item.login_id,
          is_active: false,
        });
        if (response.data.status_code === 200) {
          this.getAdminuserList();
          this.showAlertSuccess(response.data.message);
          this.stoploader();
        } else {
          this.passswordlink == [];
          this.showAlertError("Something went wrong please try again later.");
          this.stoploader();
        }
      } catch (error) {
        this.stoploader();
        console.error(error);
      }
    },

    closeDialog() {
      this.dialog = false;
    },

    //------------------- edit status  all sp users----------------------------//
    async userStatusadmin() {
      const validate = this.$refs.UserListtatus.validate();
      if (validate === true) {
        this.loaderOverlay = true;
        try {
          const responseData = await userService.userStatusadmin(
            this.userStatus.id,
            this.userStatus.remarks,
            this.userStatus.status
          );
          if (responseData && responseData.data.status_code === 200) {
            this.stoploader();
            this.showAlertSuccess(responseData.data.message);
            this.getAdminuserList();
            this.$refs.UserListtatus.reset();
            this.Statusdialog = false;
          }
          // else if (responseData.data.status_code == 401) {
          //   this.returnNewToken();
          //   this.userStatusadmin();
          //   this.stoploader();
          // }
          else {
            this.showAlertError("Something went wrong please try again later.");
            this.stoploader();
          }
        } catch (error) {
          console.log(error.response);
          this.showAlertError("Something went wrong please try again later.");
        }
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/global.scss";

// .border-b {
//   border-bottom: 1px solid $primary;
// }
.required:after {
  content: " *";
  color: $primary;
}

.no-uppercase {
  text-transform: unset !important;
}

.dialog {
  width: 80%;
}

.disabled {
  pointer-events: none;
  opacity: 0.5;
}

.v-dialog:not(.v-dialog--fullscreen) {
  overflow-y: inherit;
  background-color: white !important;
}
</style>
